<template>
  <div class="bottom-div" style="">
    <div
        class="main-chart"
        style="display: flex; flex-direction: row-reverse; float: right; max-width: 600px;"
    >
      <div class="menu-wrapper">
        <ul class="sub-menu-dropup">
          <li
              v-for="tab in tabs"
              :key="tab.id"
              :class="{
              active: selectedTab === tab.alias
            }"
              class="dropdown-item btn btn-block btn-light-gray"
              style="padding: 0; font-size: 11px; font-weight: 500;"
              @click="setClickFromMenu(tab.alias)"
          >
            <span>
              <i class="fas fa-caret-left"></i>
            </span>
            <span class="tabName"> {{ tab.name }}</span>
          </li>
        </ul>
      </div>
      <canvas id="shifts-stats-main-chart"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import apiClientCreator from "../../../helpers/api/request";
import ChartDataLabels from "chartjs-plugin-datalabels";

const retChartData = {
  type: "bar",
  options: {
    layout: {
      padding: {
        top: 26
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,
        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          // return value === 0 ? value : value;
          return value;
        }
      }
    },
    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.4)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            padding: 0,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 9
          }
        }
      ]
    },
    legend: {
      display: false
    },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    },
    tooltips: {
      mode: "index",
      intersect: false
    }
  }
};

export default {
  name: "ShiftsTopRightContainer",
  props: {
    queryObject: {
      type: Object
    },
    // rangePaymentMethodData: {
    //   type: Array
    // }
  },
  data() {
    return {
      retChartData: retChartData,
      selectedTab: "this_week",
      loading: false,
      rangePaymentMethodData: [],
      tabs: [
        { id: 1, alias: 'this_week', name: 'WTW' },
        { id: 2, alias: 'next_week', name: 'WNW' },
        { id: 3, alias: 'came_early', name: 'CE' },
        { id: 4, alias: 'came_late', name: 'CL' },
        { id: 5, alias: 'came_on_time', name: 'COT' },
        // { id: 6, alias: 'leave_early', name: 'LE' },
        // { id: 7, alias: 'leave_on_time', name: 'LOT' },
        // { id: 8, alias: 'extra_hours', name: 'EXH' },
      ]
    };
  },
  mounted() {
    this.fetchStats();
  },

  watch: {
    queryObject: function() {
      this.fetchStats();
    },
    rangePaymentMethodData: function() {
      this.createChart();
    },
    selectedTab: function() {
        this.fetchStats(this.selectedTab);
    }
  },
  methods: {
    setClickFromMenu(tab) {
      this.selectedTab = tab;
    },

    fetchStats() {
      apiClientCreator(`shifts/stats/graph/${this.selectedTab}`)
          .get("", { params: this.queryObject })
          .then(res => {
            this.rangePaymentMethodData = res.data;
          });
    },
    async createChart() {
      let labels = [];
      let Count = [];
      let chartData = this.retChartData;
      let opt = chartData.options;
      let chartId = "shifts-stats-main-chart";

      this.rangePaymentMethodData.forEach(r => {
        labels.push(r.name);
        Count.push(r.count);
      });
      if (this.retChartBar) {
        this.retChartBar.destroy();
      }

      const data = {
        labels: labels,

        datasets: [
          {
            type: "bar",
            label: this.selectedTab === 'came_early' ? 'Early, in minutes': this.selectedTab === 'came_late' ? 'Late, in minutes': "total for day",
            data: Count,
            fill: true,
            borderColor: "black",
            backgroundColor: "rgba(255,0,0,0.7)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1",
            hidden: false
          }
        ]
      };

      const ctx = document.getElementById(chartId);

      this.retChartBar = new Chart(ctx, {
        type: chartData.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
    }
  }
};
</script>

<style scoped>
.bottom-div {
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
  width: calc(44%);
}

.main-chart {
  width: 100%;
  height: 200px;
  margin: 5px;
}

.menu-wrapper {
  float: right;
  position: relative;
  top: 5px;
}

.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  min-width: 115px;
  border-radius: 0px;
  padding: 0px;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
}

li.active {
  background-color: #c12fff;
  color: #fff;
}

span.tabName {
  padding-left: 10px;
}
</style>
